import TEALIUM from "../../enums/tealium-enums";
import { track } from "../../util/tealium";

/**
 * Tracks the Watchlist page view on load.
 * page_category: action_report, page_detail: list_view_{YYYYMM}, page_section: watchlist
 */
export const watchlistPageViewTrack = (period: string) => {
  track(
    TEALIUM.U_TAG_METHOD.VIEW,
    "",
    TEALIUM.CATEGORY.WATCHLIST_AR,
    TEALIUM.CATEGORY.ACTION_REPORT,
    `list_view_${period}`,
    "",
  );
};

/**
 * Tracks click on the customize KPI button (filter icon).
 * click_action: customize_KPI, click_category: action_report, click_detail: watchlist
 */
export const watchlistCustomizeKpiTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.WATCHLIST_AR,
    "customize_KPI",
  );
};

/**
 * Tracks cancel action in the KPI selector modal.
 * click_action: cancel_customize_KPI, click_category: action_report, click_detail: watchlist
 */
export const watchlistCancelCustomizeKpiTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.WATCHLIST_AR,
    "cancel_customize_KPI",
  );
};

/**
 * Tracks apply action in the KPI selector modal.
 * click_action: apply_customize_KPI, click_category: action_report, click_detail: watchlist
 */
export const watchlistApplyCustomizeKpiTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.WATCHLIST_AR,
    "apply_customize_KPI",
  );
};

/**
 * Tracks sort ascending click.
 * click_action: sort_ascending, click_category: action_report, click_detail: watchlist
 */
export const watchlistSortAscendingTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.WATCHLIST_AR,
    "sort_ascending",
  );
};

/**
 * Tracks sort descending click.
 * click_action: sort_descending, click_category: action_report, click_detail: watchlist
 */
export const watchlistSortDescendingTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.WATCHLIST_AR,
    "sort_descending",
  );
};

/**
 * Tracks export button click.
 * click_action: export, click_category: action_report, click_detail: watchlist
 */
export const watchlistExportTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.WATCHLIST_AR,
    "export",
  );
};

/**
 * Tracks ABO profile click.
 * click_action: profile, click_category: action_report, click_detail: watchlist
 */
export const watchlistProfileTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.WATCHLIST_AR,
    "profile",
  );
};

/**
 * Tracks adding an ABO to the watchlist.
 * click_action: add_to_watchlist, click_category: action_report, click_detail: watchlist
 */
export const watchlistAddToWatchlistTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.WATCHLIST_AR,
    "add_to_watchlist",
  );
};

/**
 * Tracks removing an ABO from the watchlist.
 * click_action: remove_from_watchlist, click_category: action_report, click_detail: watchlist
 */
export const watchlistRemoveFromWatchlistTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.WATCHLIST_AR,
    "remove_from_watchlist",
  );
};

/**
 * Tracks phone icon click on the watchlist.
 * click_action: phone, click_category: action_report, click_detail: watchlist
 */
export const watchlistPhoneTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.WATCHLIST_AR,
    "phone",
  );
};

/**
 * Tracks message icon click on the watchlist.
 * click_action: message, click_category: action_report, click_detail: watchlist
 */
export const watchlistMessageTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.WATCHLIST_AR,
    "message",
  );
};
